import { useParams } from "react-router";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { RiskManagementReportDownloadModel } from "../riskManagementReportDialog/RiskManagementReportDialog.types";

export default function useRiskManagementReportPdfHooks() {
    const { id } = useParams<{ id: string }>();

    const { isLoading, data } = useDotLegalQuery<RiskManagementReportDownloadModel>(`/risk-management-report-downloads/${id}`);

    return { isLoading, note: data?.note };
}
